export const API_BASE = process.env.API_BASE || "/accounts/api";
